import { billingDollar } from "assets/icons";
import { LoadingButton } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { cancelSubscriptionApi } from "services/subscription";
import { toastMessage } from "utils/toastMessageHelper";

const CurrentPlan = ({
  currentSubscriptionDetail,
  showShimmer,
  getSubscriptionListHandler,
}) => {
  const [isCancelLoading, setIsCancelLoading] = useState(false);
  const { t } = useTranslation();

  const subscriptionCancelHandler = async (subscriptionId) => {
    try {
      setIsCancelLoading(true);
      const sendParamsData = {
        token: getFromLocal(),
        subscriptionId: subscriptionId,
      };

      const responseData = await cancelSubscriptionApi(sendParamsData);

      const { data, message = "", status } = responseData;

      if (status === 200) {
        toastMessage(message, "success", "cancelSubscription");
        getSubscriptionListHandler();
      } else {
        toastMessage(message, "error", "cancelSubscription");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsCancelLoading(false);
    }
  };

  return (
    <>
      <div className="billing_plan">
        {/* <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting,
          remaining essentially unchanged. 
        </p> */}

        <div className="billing_card_wrap">
          {showShimmer ||
            (currentSubscriptionDetail && (
              <div className="billing_card">
                <div className="head">
                  <div className="icon_wrap">
                    <img src={billingDollar} alt="" />
                    <img src={billingDollar} alt="" />
                  </div>
                </div>
                <h4>{currentSubscriptionDetail?.price || "0"}</h4>
                <h5>{currentSubscriptionDetail?.plan || "---"}</h5>
                {currentSubscriptionDetail?.features?.map((item, i) => (
                  <p key={`${item}-${i}`}>{item}</p>
                ))}
                {currentSubscriptionDetail?.slug !== "basic" && (
                  <div className="button_wrap">
                    <LoadingButton
                      className="w-100 red"
                      loading={isCancelLoading}
                      onClick={() =>
                        subscriptionCancelHandler(currentSubscriptionDetail._id)
                      }
                    >
                      {t(`BILLING_DETAIL.cancelPlan`)}
                    </LoadingButton>
                  </div>
                )}
                <div className="button_wrap"></div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default CurrentPlan;
